export default "__VITE_ASSET__Dfxu38Zu__"